import { createBrowserRouter, Navigate } from "react-router-dom";

import { AdminRoute } from "@/components/admin-route";
import { AppShell } from "@/components/app-shell";
import { AuthenticatedRoute } from "@/components/authenticated-route";
import { AuthActionPage } from "@/routes/auth-action-page";
import { BillingPage } from "@/routes/billing-page";
import { BuyPage } from "@/routes/buy-page";
import { CheckoutPage } from "@/routes/checkout-page";
import { EditTemplatePage } from "@/routes/edit-template-page";
import { EditTranslationPage } from "@/routes/edit-translation-page";
import { LoginPage } from "@/routes/login-page";
import { MyOrderEditPage } from "@/routes/my-order-edit-page";
import { MyOrderPage } from "@/routes/my-order-page";
import { MyOrdersPage } from "@/routes/my-orders-page";
import { NewSitePage } from "@/routes/new-site-page";
import { NewTemplatePage } from "@/routes/new-template-page";
import { NewTranslationPage } from "@/routes/new-translation-page";
import { NotFoundPage } from "@/routes/not-found-page";
import { OrdersListPage } from "@/routes/orders-list-page";
import { PricingPage } from "@/routes/pricing-page";
import { SetupPage } from "@/routes/setup-page";
import { SiteDetailPage } from "@/routes/site-detail-page";
import { SitesListPage } from "@/routes/sites-list-page";
import { TemplatesListPage } from "@/routes/templates-list-page";
import { TranslationDetailPage } from "@/routes/translation-detail-page";
import { TranslationsListPage } from "@/routes/translations-list-page";
import { UsersListPage } from "@/routes/users-list-page";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/action", element: <AuthActionPage /> },
  // Buy flow entry from the landing page — public; stores the selected
  // tier and routes through signup/login to checkout.
  { path: "/buy", element: <BuyPage /> },
  // Every signed-in user (buyer or admin) shares the same sidebar
  // dashboard. Buyer routes need only a signed-in user; admin routes are
  // additionally gated by AdminRoute. The sidebar itself decides which
  // nav items to show based on the same admin check (see AppSidebar).
  {
    element: (
      <AuthenticatedRoute>
        <AppShell />
      </AuthenticatedRoute>
    ),
    children: [
      { path: "/checkout", element: <CheckoutPage /> },
      { path: "/my-orders", element: <MyOrdersPage /> },
      { path: "/my-orders/:orderId", element: <MyOrderPage /> },
      { path: "/my-orders/:orderId/:section", element: <MyOrderEditPage /> },
      { path: "/setup/:orderId", element: <SetupPage /> },
      {
        element: <AdminRoute />,
        children: [
          { path: "/sites", element: <SitesListPage /> },
          { path: "/sites/new", element: <NewSitePage /> },
          { path: "/sites/:siteId", element: <SiteDetailPage /> },
          { path: "/users", element: <UsersListPage /> },
          { path: "/translations", element: <TranslationsListPage /> },
          { path: "/translations/new", element: <NewTranslationPage /> },
          { path: "/translations/:variant", element: <TranslationDetailPage /> },
          { path: "/translations/:variant/edit", element: <EditTranslationPage /> },
          { path: "/templates", element: <TemplatesListPage /> },
          { path: "/templates/new", element: <NewTemplatePage /> },
          { path: "/templates/:templateId/edit", element: <EditTemplatePage /> },
          { path: "/pricing", element: <PricingPage /> },
          { path: "/orders", element: <OrdersListPage /> },
          { path: "/billing", element: <BillingPage /> },
        ],
      },
    ],
  },
  // "/" routes through the admin gate: admins land on /sites, everyone
  // else is forwarded by AdminRoute to /my-orders (their order home).
  { path: "/", element: <Navigate to="/sites" replace /> },
  { path: "/404", element: <NotFoundPage /> },
  { path: "*", element: <Navigate to="/404" replace /> },
]);
